/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Complete_OkInputs */

const cs_settings_calendar_complete_ok = /** @type {(inputs: Settings_Calendar_Complete_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalendář je připojený`)
};

const en_settings_calendar_complete_ok = /** @type {(inputs: Settings_Calendar_Complete_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar connected`)
};

/**
* | output |
* | --- |
* | "Calendar connected" |
*
* @param {Settings_Calendar_Complete_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_complete_ok = /** @type {((inputs?: Settings_Calendar_Complete_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Complete_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_complete_ok(inputs)
	return cs_settings_calendar_complete_ok(inputs)
});